<template>
  <div id="app">
    <Header :name="name" :description="description" />
    <router-view></router-view>
    <Footer :linkUrl="linkUrl" />
  </div>
</template>

<script>
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';

export default {
  name: 'app',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      name: 'Jeffrey Ludden',
      description: 'Experienced web developer passionate about performance, usability, and responsive design.',
      linkUrl: 'https://www.jeffludden.com',
    };
  }
}
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
body {
  max-width: 1000px;
  margin: 0 auto;
  background: #fafafa;
  border: 1px solid #c0c0c0;
}
#app {
  background: #fff;
}
.grid {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0 auto;
  padding: 0;
  max-width: 1340px
}
.grid-left {
  width: 70%;
  padding: 0 1.5rem 1.5rem;
}
.grid-right {
  width: 30%;
  background: #f0f0f0;
  padding: 0 1rem 1.5rem;
}
h3.divider {
  border-bottom: 1px solid #c0c0c0;
  padding-bottom: 0.3rem;
  margin-bottom: 0.5rem;
}
.full {
  padding: 1.5rem;
  min-height: 60vh;
}
a,
a:visited {
  color: #08f;
}
a:hover {
  transform: scale(105%);
}

@media (max-width: 640px) {
  /* we are now too small for the right rail -- we need to reorganize */
  .main-content {
    display: block;
    & .grid-left {
      width: auto;
      padding: 0 0.9rem .3rem;
      
      .section-details {
        padding-top: 0.1rem;   
      }
    }
    & .grid-right {
      width: auto;
      padding-top: 0.1rem;
    }
  }
}
</style>
